import {cn} from '@/lib/utils'
import React from 'react'

interface IWuInputErrorProps
  extends React.HTMLAttributes<HTMLParagraphElement> {
  message?: string
}
export const WuInputError: React.FC<IWuInputErrorProps> = props => {
  const {message, className, ...rest} = props
  return (
    <p {...rest} className={cn('wu-input-error break-words', className)}>
      {message}
    </p>
  )
}
